import React, { Fragment } from 'react';
import type { RouteComponentProps } from 'react-router-dom';

import { ListHelmet } from 'components';
import { AsyncOutrightsList } from 'modules/outright/async';
import useOutrights from './useOutrights';

import './outrights.scss';

type Props = RouteComponentProps<any>;

const Outrights: React.FC<Props> = () => {
    const { isCompact } = useOutrights();

    return (
        <Fragment>
            {isCompact && <div styleName="divider" />}
            <ListHelmet />
            <AsyncOutrightsList />
        </Fragment>
    );
};

export default Outrights;
